export const getYesNoLabel = (resultInfo: boolean) => {
    if (resultInfo === true) {
        return "Yes";
    } else if (resultInfo === false) {
        return "No";
    } else {
        return "";
    }
};
